export default __webpack_public_path__ + "static/media/pt.a200ca6e.svg";